import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=655d5ef9&scoped=true"
import script from "./entrance.vue?vue&type=script&lang=js"
export * from "./entrance.vue?vue&type=script&lang=js"
import style0 from "./entrance.vue?vue&type=style&index=0&id=655d5ef9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d5ef9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\01_Projects\\zr_code\\exam_registration_api\\exam-registration-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655d5ef9')) {
      api.createRecord('655d5ef9', component.options)
    } else {
      api.reload('655d5ef9', component.options)
    }
    module.hot.accept("./entrance.vue?vue&type=template&id=655d5ef9&scoped=true", function () {
      api.rerender('655d5ef9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/entrance.vue"
export default component.exports